import { render } from "./MerchCard.vue?vue&type=template&id=3635ab4c&scoped=true"
import script from "./MerchCard.vue?vue&type=script&lang=js"
export * from "./MerchCard.vue?vue&type=script&lang=js"

import "./MerchCard.vue?vue&type=style&index=0&id=3635ab4c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3635ab4c"]])

export default __exports__